import Api from '@/services/API';

export default class Auth extends Api {
  static base = import.meta.env.VUE_APP_API_HOST;

  static resource = '/member/login';

  constructor(resource: string, options: Record<string, unknown> = {}, http = null) {
    super(Auth.normalize(Auth.base, resource), options, http);
  }

  static build() {
    return new this(this.resource);
  }

  login(username: string, password: string, captcha: string) {
    const data = {
      email: username,
      password: password,
      captcha: captcha,
    };

    return this.post('', data);
  }

  logout() {
    return this.post();
  }
}
